(() => {
  const script = document.currentScript;
  const cartPath = new URL(script.dataset.cartUrl, window.location.origin).pathname.replace(/\/$/, '');

  const initialize = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    customElements.whenDefined('cart-drawer').then(() => {
      const current = new URL(window.location.href);
      if (current.searchParams.get('bm-cart') === 'open') {
        drawer.open(document.getElementById('cart-icon-bubble'));
        current.searchParams.delete('bm-cart');
        window.history.replaceState(window.history.state, '', current.pathname + current.search + current.hash);
      }

      document.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
        if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        const destination = new URL(link.href, window.location.origin);
        if (destination.origin !== window.location.origin || destination.pathname.replace(/\/$/, '') !== cartPath || destination.search || destination.hash) return;
        event.preventDefault();
        drawer.open(link);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
